export default __webpack_public_path__ + "static/media/img-buero-purple.39decc72.jpg";